<template>
    <div class="close-header-title no-con">
        <section class="privacy-section">
            <div class="container">
                <div class="main-heading">
                    <h1>FAQ</h1>
                    <p>Want to know more? Learn how to make the most of our site</p>
                </div>
                <div class="content-section center">
                    <h2>What is Vanovy?</h2>
                    <p>Vanovy is a rental platform specializing in temporary housing solutions, offering lease
                        durations ranging from 1 to 12 months. We are committed to providing the most affordable options
                        available, without charging fees to tenants, and securing exclusive discounts directly from
                        property owners.</p>

                    <h2>What types of accommodations are available through Vanovy?</h2>
                    <p>Our platform features a broad selection of accommodations, including studios, private rooms, and
                        entire apartments. These are curated to meet the needs of students, professionals on temporary
                        assignments, families in transition, expatriates, digital nomads, and others seeking mid-term
                        housing.</p>

                    <h2>How does the rental process work?</h2>
                    <p>The process begins by selecting the accommodation that best fits your needs. Reservations are
                        completed directly through our platform. Vanovy facilitates secure payments and oversees
                        communication between tenants and property owners. Once confirmed, tenants can proceed with
                        peace of mind, supported by our dedicated team.
                    </p>
                    <h2>Are there any fees for the tenant using the platform?</h2>
                    <p>No. Vanovy does not charge commissions or service fees to tenants. Our model is designed
                        to prioritize accessibility and fairness.</p>
                    <h2>Is the payment process secure?</h2>
                    <p>Yes. All payments are processed through secure and transparent systems. Vanovy supervises
                        each transaction to ensure the safety and confidence of both tenants and property owners.
                    </p>
                    <h2>What support is available if issues arise with the accommodation?
                    </h2>
                    <p>Vanovy acts as an intermediary in the event of any dispute or issue, providing prompt and
                        comprehensive support throughout the duration of the stay.</p>
                    <h2>Can a reservation be canceled?</h2>
                    <p>Yes. However, cancellation policies are determined by each property owner. All relevant terms and
                        conditions will be clearly communicated prior to the confirmation of any reservation.</p>
                    <h2>In which countries does Vanovy operate?</h2>
                    <p>We are currently expanding our geographical reach. All available locations can be viewed directly
                        on the platform, with new destinations being added regularly as part of our ongoing growth
                        strategy.</p>
                    <h2>How does the guest cancellation policy work?</h2>
                    <p>
                        Our <a href="https://www.vanovy.com/guest-terms-and-conditions" target="_blank">
                            guest cancellation policy
                        </a>
                        explains how refunds and charges are handled if you decide to cancel your booking. The exact
                        terms depend on your reservation type, booking dates, and selected rate.
                    </p>
                    <ul>
                        <li>
                            <strong>Free Cancellation Window:</strong>
                            <p>If you cancel within the free cancellation period stated at the time of booking, you will
                            receive a full refund.</p>
                        </li>
                        <li>
                            <strong>After the Free Cancellation Period:</strong>
                            <p>Cancellations made after the deadline may result in a partial refund or no refund, based on
                            your booking terms.</p>
                        </li>
                        <li>
                            <strong>Non-Refundable / Special Rates:</strong>
                            <p>Some discounted or special offer bookings are non-refundable, even if cancelled early.</p>
                        </li>
                        <li>
                            <strong>How it Applies:</strong>
                            <p>Your specific cancellation terms are shown in your booking confirmation email and booking
                            details.</p>
                        </li>
                    </ul>
                    <p>
                        For complete and detailed information, please review the full
                        <a href="https://www.vanovy.com/guest-terms-and-conditions" target="_blank">
                            Guest Terms and Conditions
                        </a>
                        or contact our support team for assistance.
                    </p>
                    <h2>How does the host cancellation policy work?</h2>
                    <p>
                        Our <a href="https://www.vanovy.com/host-terms-and-conditions" target="_blank">
                            host cancellation policy
                        </a>
                        explains what happens if a host cancels a confirmed reservation and how any related charges or
                        consequences apply. The exact terms vary based on the type of reservation and timing of the
                        cancellation, as outlined in the full host agreement.
                    </p>
                    <ul>
                        <li>
                            <strong>Host Cancellation Timing:</strong>
                            <p>If a host cancels a confirmed reservation well in advance, there may be minimal or no
                            penalties, but this depends on the specific terms agreed at the time of listing.</p>
                        </li>
                        <li>
                            <strong>Late Cancellations:</strong>
                            <p>Cancellations close to the scheduled check-in date may result in penalties or fees for the
                            host, which could include service charges, reduced payout, or other consequences as
                            specified in your host terms.</p>
                        </li>
                        <li>
                            <strong>Impact on Guests:</strong>
                            <p>When a host cancels, guests may be entitled to refunds, assistance with re-booking, or other
                            remedies depending on the policy framework.</p>
                        </li>
                        <li>
                            <strong>How it Applies:</strong>
                            <p>Your responsibilities and any financial implications for cancelling a reservation are
                            defined in your host agreement and reflected in your dashboard or confirmation messages.</p>
                        </li>
                    </ul>
                    <p>
                        For complete and detailed information, please review the full
                        <a href="https://www.vanovy.com/host-terms-and-conditions" target="_blank">
                            Host Terms and Conditions
                        </a>
                        or contact our support team if you have questions about a specific reservation.
                    </p>
                    <h2>If both parties disagree, what should they do?</h2>
                    <p>Contact our support team to find the best solution for both parties.</p>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
import API from '@/api';
import axios from 'axios';
import Vue from 'vue';

import { Loader } from '@googlemaps/js-api-loader';
export default {
    name: 'faqs',
    components: {
    },
    data() {
        return {

        }
    },
    mounted() {

    },
    methods: {
    },
    computed: {
    },
    created() {
    },
}
</script>
<style>
h2 {
    font-size: 32px;
    font-weight: 700;
    line-height: 42px;
    margin-bottom: 5px !important;
}
</style>